
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.5 24c0 8.562-6.94 15.5-15.5 15.5-8.56 0-15.5-6.938-15.5-15.5 0-8.557 6.94-15.5 15.5-15.5 8.56 0 15.5 6.943 15.5 15.5zM24.416 13.625c-3.406 0-5.579 1.435-7.284 3.985a.751.751 0 00.17 1.016l2.168 1.644a.75.75 0 001.042-.132c1.116-1.416 1.882-2.238 3.581-2.238 1.277 0 2.856.822 2.856 2.06 0 .936-.773 1.417-2.033 2.124-1.47.824-3.416 1.85-3.416 4.416v.25c0 .414.336.75.75.75h3.5a.75.75 0 00.75-.75v-.083c0-1.78 5.2-1.853 5.2-6.667 0-3.625-3.761-6.375-7.284-6.375zM24 29.125A2.878 2.878 0 0021.125 32 2.878 2.878 0 0024 34.875 2.878 2.878 0 0026.875 32 2.878 2.878 0 0024 29.125z","fill":"#535353"}})])
          )
        }
      }
    